import "./LoadingIndicator.css"

function LoadingIndicator({ isLoading }) {
  return (
    isLoading ?
      <p className='loading_indicator'>
        Loading...
      </p>
    : null
  );
}

export default LoadingIndicator;